import {useCallback} from 'react'

import {SystemsEngineerEventName} from '../utils'

type TrackEventCallback = <T extends SystemsEngineerEventName>(
  eventName: T,
  data: Record<string, unknown>
) => void

export const useTrackSystemsEngineerAnalytics = (trackEvent: TrackEventCallback) => {
  return useCallback(
    <T extends SystemsEngineerEventName>(eventName: T, data: Record<string, unknown> = {}) => {
      trackEvent(eventName, data)
    },
    [trackEvent]
  )
}
